import { render } from "./bp12bgDirection.vue?vue&type=template&id=a10b9678&scoped=true"
import script from "./bp12bgDirection.vue?vue&type=script&lang=js"
export * from "./bp12bgDirection.vue?vue&type=script&lang=js"

import "./bp12bgDirection.vue?vue&type=style&index=0&id=a10b9678&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a10b9678"]])

export default __exports__